import authService from './authService';
import { apiErrorFrom } from '@/utils/apiError';
import {
  CorreiosCredentialsTestResult,
  CorreiosIntegration,
  CorreiosIntegrationFormData,
} from '../types/correiosIntegration';
import { ApiResponse } from '../types/common';

// Integração Correios por empresa — /shipping/correios-integrations (ERPApi).
// Permissões: shipping_integrations.read (listar) e shipping_integrations.write (demais).

class CorreiosIntegrationService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  async list(): Promise<CorreiosIntegration[]> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.get('/shipping/correios-integrations');
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao carregar as integrações Correios');
    const data: ApiResponse<CorreiosIntegration[]> = await res.json();
    return data.data ?? [];
  }

  /** Cria ou atualiza a linha da empresa. Troca de credencial zera o token no backend. */
  async upsert(companyId: number, payload: CorreiosIntegrationFormData): Promise<CorreiosIntegration> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.put(`/shipping/correios-integrations/${companyId}`, payload);
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao salvar a integração Correios');
    const data: ApiResponse<CorreiosIntegration> = await res.json();
    return data.data!;
  }

  async remove(companyId: number): Promise<void> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.delete(`/shipping/correios-integrations/${companyId}`);
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao excluir a integração Correios');
  }

  /** Um POST de autenticação nos Correios com as credenciais gravadas (sem persistir token). */
  async testCredentials(companyId: number): Promise<CorreiosCredentialsTestResult> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.post(`/shipping/correios-integrations/${companyId}/test`);
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao testar as credenciais');
    const data: ApiResponse<CorreiosCredentialsTestResult> = await res.json();
    return data.data!;
  }

  async resetToken(companyId: number): Promise<void> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.post(`/shipping/correios-integrations/${companyId}/reset-token`);
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao zerar o token');
  }
}

export const correiosIntegrationService = new CorreiosIntegrationService();
export default correiosIntegrationService;
